import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

export default class AddResultDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleChange = event => {
    this.setState({ [event.target.id]: event.target.value });
  };

  render() {
    const { onSubmit, onCancel, trigger } = this.props;

    return (
      <div>
        <Dialog
          open={trigger !== undefined ? trigger : false}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Add Result</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Enter bib number and time (make sure to keep time format)
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              type="number"
              id="bib"
              onChange={this.handleChange}
              label="Bib Number"
              fullWidth
            />
            <TextField
              margin="dense"
              id="time"
              onChange={this.handleChange}
              label="Time (mm:ss) or (hh:mm:ss)"
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => onSubmit(this.state.bib, this.state.time)}
              color="primary"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
